<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/report/rescueFundPayout")
          i.fa.fa-poll-h
          span.ml-1(@click="getpayoutList(true)") {{ $t("ui.rescue_fund_payout") }}
          span(v-if="child") {{ " / " + $t("ui.payout_list") }}
  div.row
    div.col-md-12
      div.card.rebatelist
        div.card-header
          div.row
            div.col-md-12.mb-1
              .form-row
                template(v-if="!child")
                  .col-md-2
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        span {{ $t('ui.cycle') }}
                      b-form-select(v-model="rescue_cycle" @change="getpayoutList(true)")
                        option(value="") {{ $t('ui.all') }}
                        option(value="DAILY") {{ $t('ui.daily') }}
                        option(value="WEEKLY") {{ $t("ui.weekly") }}
                        option(value="MONTHLY") {{ $t("ui.monthly") }}
                  .col-md-2
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        span {{ $t('ui.method') }}
                      b-form-select(v-model="payout_method" @change="getpayoutList(true)")
                        option(value="") {{ $t('ui.all') }}
                        option(value="INBOX") {{ $t('ui.inbox') }}
                        option(value="CREDIT") {{ $t("ui.credit") }}
                  .col-md-3
                    DateRangePicker(:value="dateRange" @update="getData")
                template(v-else)
                  .col-md-3
                    DateRangePicker(:value="dateRange2" @update="getData2" singleDatePicker=true)
                .col-md-2
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="submit()"
                    variant="success"
                    size="sm"
                  )
                  //- jsonToExcel(v-if="payoutList.length > 0" mode="RebateSummary" tbl="tblList" :date="dateRange") 
        div.card-body
          div.mb-1(v-if="child")
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll(v-if="!child")
                table.tablex(style="width: 50%;")
                  thead
                    tr
                      th.sticky-position.text-center(width="5%")
                        span #
                      th.sticky-position.text-left(width="20%")
                        span(:title="$t('ui.working_date')") {{ $t('ui.working_date') }}
                      th.sticky-position.text-right(width="20%")
                        span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                      th.sticky-position.text-right(width="20%")
                        span(:title="$t('ui.actual_amount')") {{ $t('ui.actual_amount') }}
                      th.sticky-position.text-right(width="20%")
                        span(:title="$t('ui.rounded_amount')") {{ $t('ui.rounded_amount') }}
                  tbody.clusterize-content
                    tr(v-if="payoutList.length == 0")
                      td(:colspan="5").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in payoutList")
                      td.text-center
                        span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        b-link(href="javascript:void(0);" @click="getPayoutListWorkingDate(item.working_date)")
                          span.font-weight-bold(:title="$moment(item.working_date).format('YYYY-MM-DD')") {{ $moment(item.working_date).format('YYYY-MM-DD') }}
                      td.text-right
                        span(:title="$n(item.winlose, 'currency')") {{ item.winlose != null ? $n(item.winlose, 'currency') : null }}
                      td.text-right
                        span(:title="$n(item.actual_amount, 'currency')") {{ item.actual_amount != null ? $n(item.actual_amount, 'currency') : null }}
                      td.text-right
                        span(:title="$n(item.rounded_amount, 'currency')") {{ item.rounded_amount != null ? $n(item.rounded_amount, 'currency') : null }}
                      tr(v-if="showTotal")
                        td.text-right(colspan="2")
                          span {{ $t("ui.sub_total") }}
                          br
                          span {{ $t("ui.grand_total") }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinlose)" :title="$n(subTotalWinlose, 'currency')") {{ $n(subTotalWinlose, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinlose)" :title="$n(grandTotalWinlose, 'currency')") {{ $n(grandTotalWinlose, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalActualAmount)" :title="$n(subTotalActualAmount, 'currency')") {{ $n(subTotalActualAmount, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalActualAmount)" :title="$n(grandTotalActualAmount, 'currency')") {{ $n(grandTotalActualAmount, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalRoundedAmount)" :title="$n(subTotalRoundedAmount, 'currency')") {{ $n(subTotalRoundedAmount, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalRoundedAmount)" :title="$n(grandTotalRoundedAmount, 'currency')") {{ $n(grandTotalRoundedAmount, 'currency') }}
              .clusterize-scroll(v-else)
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position.text-center(width="5%")
                        span #
                      th.sticky-position.text-left.sortable(width="15%" @click="sortOrder('account_id')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id')")
                      th.sticky-position.text-left(width="15%")
                        span(:title="$t('ui.rescue_id')") {{ $t('ui.rescue_id') }}
                      th.sticky-position.text-left(width="20%")
                        span(:title="$t('ui.rescue_name')") {{ $t('ui.rescue_name') }}
                      th.sticky-position.text-left(width="12%" @click="sortOrder('start_date')")
                        span(:title="$t('ui.cycle')") {{ $t('ui.cycle') }}
                        i(:class="changeSortKey('start_date')")
                      th.sticky-position.text-left.sortable(width="12%" @click="sortOrder('min_lose')")
                        span(:title="$t('ui.min_lose')") {{ $t('ui.min_lose') }}
                        i(:class="changeSortKey('min_lose')")
                      th.sticky-position.text-left.sortable(width="15%" @click="sortOrder('total_winlose')")
                        span(:title="$t('ui.total_winlose')") {{ $t('ui.total_winlose') }}
                        i(:class="changeSortKey('total_winlose')")
                      th.sticky-position.text-left.sortable(width="10%" @click="sortOrder('rescue_rate')")
                        span(:title="$t('ui.rate')") {{ $t('ui.rate') }}
                        i(:class="changeSortKey('rescue_rate')")
                      th.sticky-position.text-left.sortable(width="13%" @click="sortOrder('max_payout')")
                        span(:title="$t('ui.max_payout')") {{ $t('ui.max_payout') }}
                        i(:class="changeSortKey('max_payout')")
                      th.sticky-position.text-left(width="13%" @click="sortOrder('actual_amount')")
                        span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                        i(:class="changeSortKey('actual_amount')")
                      th.sticky-position.text-left(width="10%" @click="sortOrder('action_status')")
                        span(:title="$t('ui.status')") {{ $t('ui.status') }}
                        i(:class="changeSortKey('action_status')")
                      th.sticky-position.text-left(width="18%" @click="sortOrder('action_date')")
                        span(:title="$t('ui.date')") {{ $t('ui.date') }}
                        i(:class="changeSortKey('action_date')")
                      th.text-center.sticky-position(width="5%")
                        span &nbsp;
                  tbody.clusterize-content
                    tr(v-if="payoutListWorkingDate.length == 0")
                      td(:colspan="13").text-center
                        span {{ $t('message.no_data_available') }}
                    template(v-for="(item, index) in payoutListWorkingDate")
                      tr
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td.text-left
                          span(:title="item.account_id") {{ item.account_id }}
                        td.text-left
                          span(:title="item.rescue_id") {{ item.rescue_id }}
                        td.text-left
                          span(:title="item.rescue_name") {{ item.rescue_name }}
                        td.text-left
                          span(:title="item.rescue_cycle") {{ item.rescue_cycle }}
                          br
                          span(:title="$moment(item.start_date).format('YYYY-MM-DD')") {{ $moment(item.start_date).format('YYYY-MM-DD') }}
                          br
                          span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ $moment(item.end_date).format('YYYY-MM-DD') }}
                        td.text-left
                          span(:title="$n(item.min_lose, 'currency')") {{ item.min_lose != null ? $n(item.min_lose, 'currency') : null }}
                        td.text-left
                          span.font-weight-bold(:title="$n(item.total_winlose, 'currency')")
                            b-link.clickable(href="javascript:void(0);" @click="onGetProvider(item)") {{ item.total_winlose != null ? $n(item.total_winlose, 'currency') : null }}
                        td.text-left
                          span(:title="$n(item.rescue_rate, 'currency')") {{ item.rescue_rate != null ? $n(item.rescue_rate, 'currency') : null }}
                        td.text-left
                          span(:title="$n(item.max_payout, 'currency')") {{ item.max_payout != null ? $n(item.max_payout, 'currency') : null }}
                        td.text-left
                          span(:title="$n(item.actual_amount, 'currency')") {{ item.actual_amount != null ? $n(item.actual_amount, 'currency') : null }}
                          br
                          i.fa.ml-1.fa-arrow-down(v-if="item.actual_amount && item.rounded_amount")
                          br
                          span(:title="$n(item.rounded_amount, 'currency')") {{ item.rounded_amount != null ? $n(item.rounded_amount, 'currency') : null }}
                        td.text-left
                          span.font-weight-bold.text-info(v-if="item.action_status.trim().toUpperCase() == 'SKIP'") {{ item.action_status.trim().toUpperCase() }}
                          span.font-weight-bold.text-success(v-if="item.action_status.trim().toUpperCase() == 'SUCCESS'") {{ item.action_status.trim().toUpperCase() }}
                        td.text-left
                          span(:title="$moment(item.action_date).format('YYYY-MM-DD HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD HH:mm:ss') }}
                        td.text-center
                          i.fa.ml-1(:title="$t('ui.detail')" size="sm" @click="onOffDetail(item)" :class="currId == item.id ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                      tr.text-center(v-if="isShowDetail == true && currId == item.id")
                        td(colspan="13")
                          table.tablex(style="width: 60%;").mb-2.m-auto
                            thead
                              tr
                                th.sticky-position.text-left(width="10%")
                                  span {{ $t("ui.payout_method") }}
                                th.sticky-position.text-left(width="10%")
                                  span {{ $t("ui.inbox_id") }}
                                th.sticky-position.text-left(width="30%")
                                  span {{ $t("ui.target_group") }}
                                th.sticky-position.text-left(width="10%")
                                  span {{ $t("ui.member_vip_id") }}
                                th.sticky-position.text-left(width="20%")
                                  span {{ $t("ui.vip_list") }}
                                //- th.sticky-position.text-left(width="10%")
                                //-   span {{ $t("ui.member_vip_name") }}
                                //- th.sticky-position.text-left(width="10%")
                                //-   span {{ $t("ui.member_vip_level") }}
                                //- th.sticky-position.text-left(width="10%")
                                //-   span {{ $t("ui.rescue_vip_id") }}
                                //- th.sticky-position.text-left(width="10%")
                                //-   span {{ $t("ui.rescue_vip_name") }}
                                //- th.sticky-position.text-left(width="10%")
                                //-   span {{ $t("ui.rescue_vip_level") }}
                            tbody.clusterize-content
                              tr
                                td.text-left
                                  span(:title="item.payout_method") {{ item.payout_method }}
                                td.text-left
                                  span(:title="item.inbox_id") {{ item.inbox_id }}
                                td.text-left
                                  span(:title="item.target_group") {{ item.target_group }}
                                td.text-left
                                  span(:title="item.member_vip_id") {{ item.member_vip_id }}
                                td.text-left
                                  span(:title="item.vip_list") {{ item.vip_list }}
                                //- td.text-left
                                //-   span(:title="item.member_vip_name") {{ item.member_vip_name }}
                                //- td.text-left
                                //-   span(:title="item.member_vip_level") {{ item.member_vip_level }}
                                //- td.text-left
                                //-   span(:title="item.rescue_vip_id") {{ item.rescue_vip_id }}
                                //- td.text-left
                                //-   span(:title="item.rescue_vip_name") {{ item.rescue_vip_name }}
                                //- td.text-left
                                //-   span(:title="item.rescue_vip_level") {{ item.rescue_vip_level }}

    getrescuefundprovider(ref="getrescuefundprovider" :item="selectedPayout" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import jsonToExcel from "@/library/jsonToExcel.vue";
import getrescuefundprovider from "@/components/report/getRescueFundProvider.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    getrescuefundprovider
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    dateRange2: {
      startDate: null,
      endDate: null,
    },
    child: false,
    rescue_cycle: "",
    payout_method: "",
    currId: null,
    payoutList: [],
    payoutListWorkingDate: [],
    payoutProvider: [],
    currentPage: 1,
    totalRow: 0,
    isShowDetail: false,
    showTotal: false,
    sortKey: "account_id",
    sortType: "asc",
    subTotalWinlose: 0,
    grandTotalWinlose: 0,
    subTotalActualAmount: 0,
    grandTotalActualAmount: 0,
    subTotalRoundedAmount: 0,
    grandTotalRoundedAmount: 0,
    selectedPayout: null,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.getpayoutList(true);
  },
  methods: {
    onGetProvider(e) {
      this.selectedPayout = e;
      this.$refs.getrescuefundprovider.$refs.getRescueFundProvider.show();
    },
    onOffDetail(item) {
      if (this.isShowDetail == true) {
        if (this.currId == item.id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = false;
          this.currId = null;
          this.isShowDetail = true;
          this.currId = item.id;
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.id;
      }
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getPayoutListWorkingDate(this.dateRange2.startDate);

    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getpayoutList(true);
    },
    getData2(currentValue) {
      this.dateRange2.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange2.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getPayoutListWorkingDate(currentValue.startDate);
    },
    submit() {
      if(this.child) {
        this.getPayoutListWorkingDate(this.dateRange2.startDate)
      } else {
        this.getpayoutList(true)
      }
    },
    getpayoutList: function(isSearch) {
      this.child = false
      if (this.checkDateRange()) {
        let url = config.rescueFundPayoutSummaryUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          rescue_cycle: this.rescue_cycle == "" ? null : this.rescue_cycle,
          payout_method: this.payout_method == "" ? null : this.payout_method
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearPayoutList()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.list.length > 0) {
                    this.showTotal = true
                    response.data.ds.list.forEach(value => {
                      this.subTotalWinlose = parseFloat(this.subTotalWinlose) + parseFloat(value["winlose"]);
                      this.subTotalActualAmount = parseFloat(this.subTotalActualAmount) + parseFloat(value["actual_amount"]);
                      this.subTotalRoundedAmount = parseFloat(this.subTotalRoundedAmount) + parseFloat(value["rounded_amount"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalWinlose = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalActualAmount = response.data.ds.grand_total[0]["actual_amount"];
                      this.grandTotalRoundedAmount = response.data.ds.grand_total[0]["rounded_amount"];
                    }

                    this.payoutList = response.data.ds.list;
                  } else {
                    this.clearPayoutList()
                  }
                } else {
                  this.clearPayoutList()
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.clearPayoutList();
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getPayoutListWorkingDate(date) {
      this.child = true
      this.dateRange2.startDate = this.$moment(date).format('YYYY-MM-DD');
      this.dateRange2.endDate = this.$moment(date).format('YYYY-MM-DD');
      let url = config.rescueFundPayoutListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        working_date: date,
        rescue_cycle: this.rescue_cycle == "" ? null : this.rescue_cycle,
        payout_method: this.payout_method == "" ? null : this.payout_method,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.clearPayoutListWorkingDate()
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.dt.length > 0) {
                  this.payoutListWorkingDate = response.data.dt;
                  this.totalRow = this.payoutListWorkingDate.length > 0 ? this.payoutListWorkingDate[0].totalrows : 0;
                } else {
                  this.clearPayoutListWorkingDate()
                }
              } else {
                this.clearPayoutListWorkingDate()
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getRebateProvider(payout_id) {
      this.clearPayoutProvider()
      let url = config.rebateProviderUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        payout_id: payout_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.dt.length > 0) {
                  this.payoutProvider = response.data.dt;
                } else {
                  this.clearPayoutProvider()
                }
              } else {
                this.clearPayoutProvider()
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearPayoutList() {
      this.showTotal = false
      this.payoutList = []
      this.subTotalWinlose = 0
      this.grandTotalWinlose = 0
      this.subTotalActualAmount = 0
      this.grandTotalActualAmount = 0
      this.subTotalRoundedAmount = 0
      this.grandTotalRoundedAmount = 0
    },
    clearPayoutListWorkingDate() {
      this.totalRow = 0;
      this.payoutListWorkingDate = []
    },
    clearPayoutProvider() {
      this.payoutProvider = []
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      // this.getpayoutList(true);
      this.getPayoutListWorkingDate(this.dateRange2.startDate)
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      // this.getpayoutList();
      this.getPayoutListWorkingDate(this.dateRange2.startDate)
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>